// ─────────────────────────────────────────────────────────────────────────────
// Note type availability
//
// The Note Type Studio's Availability section writes these into the note type's
// `templateSettings`:
//   allStaff !== false  → every staff member EXCEPT the ids in `staffExcluded`
//                         (the default; staff added later are included)
//   allStaff === false  → ONLY the ids in `staff` (an explicit allow-list)
//
// Both lists hold staff ids and are persisted as part of templateSettings (see
// studio/schema.js), so the rule has to be applied client-side wherever staff
// pick a note type to write.
// ─────────────────────────────────────────────────────────────────────────────

export const canStaffUseNoteType = (noteType, staffId) => {
  const settings = noteType?.templateSettings || {};
  const id = String(staffId || "");
  if (settings.allStaff === false) {
    if (!id) return false;
    return (settings.staff || []).map(String).includes(id);
  }
  if (!id) return true;
  return !(settings.staffExcluded || []).map(String).includes(id);
};

// Filters a note-type list down to what the logged-in user is allowed to use.
// The org/owner account is not a staff record, so it can never appear in a
// template's staff list — it always sees every note type (and manages them in
// Note Settings, which is deliberately never filtered).
export const noteTypesForUser = (ntypes, profile) => {
  if (!Array.isArray(ntypes)) return [];
  if (profile?.user?.type !== "staff") return ntypes;
  return ntypes.filter((nt) => canStaffUseNoteType(nt, profile?.user?.id));
};
